import request from '@/utils/request';
import { dictionaryMarkdownEndpoint } from '@/constants/urls';

const markdown = (datasetCode, code) => request({
  method: 'GET',
  url: dictionaryMarkdownEndpoint(datasetCode, code),
});

const DatasetMarkdownService = {
  markdown,
};

export default DatasetMarkdownService;
